// extracted by mini-css-extract-plugin
module.exports = {"rule_factor_img_wrapper":"RuleFactorImg_rule_factor_img_wrapper__2em7q"};